import cx from 'classnames'
import type { ComponentProps } from 'react'

import { buttonStyles } from '../../actions/button/buttonStyles'

type BadgeType = 'current' | 'new' | 'prev'
type Props = ComponentProps<'span'> & {
  type: BadgeType
}

export const CompareBadge = ({ type, onClick, children }: Props) => {
  const isHighlighted = type === 'new' || type === 'prev'
  return (
    <span
      className={cx(
        {
          prev: 'bg-diffPrevious-light dark:bg-diffPrevious-dark',
          new: 'bg-diffCurrent-light dark:bg-diffCurrent-dark',
          current: '',
        }[type],
        isHighlighted
          ? 'px-1 -mx-1 rounded-md text-amaze-ink dark:text-amaze-inkBright *:text-inherit!'
          : onClick &&
              buttonStyles({
                disabled: false,
                variant: 'text',
                isDanger: false,
                isFullWidth: false,
              }),
      )}
      role={onClick && children ? 'button' : ''} // No hover indicator if no content
      onClick={children ? onClick : undefined} // No click if no content
    >
      {children}
    </span>
  )
}
